import FooterCol from "./footerCol";

export default FooterCol;